import styles from './acceptance_rate.module.css';

export const AcceptanceRate = ({value}: Props) => {
  if (!value) {
    return <span className={styles.na}>N/A</span>;
  }
  return <>{Math.round(value * 100)}%</>;
};

type Props = {
  value: number;
};
